class InfoDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener("keyup", (evt) => evt.code === "Escape" && this.close());
    this.querySelector("#InfoDrawer-Overlay").addEventListener("click", this.close.bind(this));
    this.initIngredientsInfoButton();
    this.initBoosterInfoButton();
    this.initExpertsInfoButton();
    this.initHealthInfoButton();
  }

  initIngredientsInfoButton() {
    const infoLinks = [...document.querySelectorAll('.ingredient_wrapper')];
    const infoDrawerContent = document.querySelector('.info-drawer__content');
    infoLinks.forEach((infoLink)=>{

      infoLink.addEventListener('click', (event) => {
        event.preventDefault();
        this.open(infoLink)
        const ingredientContent = infoLink.querySelector('.ingredient-drawer-content');
        infoDrawerContent.innerHTML = ingredientContent.innerHTML;
      });
      infoLink.addEventListener("keydown", (event) => {
        if (event.key === "Enter") {
          infoLink.click();
        }
      });
    })

  }

  initBoosterInfoButton() {
    const boosterInfoLinks = [...document.querySelectorAll(".booster__info-details")];
    const infoDrawerContent = document.querySelector(".info-drawer__content");

    boosterInfoLinks.forEach((infoLink) => {
      infoLink.addEventListener("click", (event) => {
        event.preventDefault();
        this.open(infoLink);
        const targetBoosterID = event.currentTarget.dataset.boosterId;
        const content = document.querySelector(`.drawer-content__${targetBoosterID}`)
        const targetBoosterDrawerContent = content ? content.innerHTML : '';
        if (infoDrawerContent) {
          infoDrawerContent.innerHTML = targetBoosterDrawerContent;
        }
      });
      infoLink.addEventListener("keydown", (event) => {
        if (event.key === "Enter") {
          infoLink.click();
        }
      });
    });
  }

  initExpertsInfoButton() {
    const infoLinks = [...document.querySelectorAll('.expert-wrapper')];
    const infoDrawerContent = document.querySelector('.info-drawer__content');

    infoLinks.forEach((infoLink)=>{
      infoLink.addEventListener('click', (event) => {
        event.preventDefault();
        this.open(infoLink)
        const expertContent = infoLink.querySelector('.expert-drawer-content');
        infoDrawerContent.innerHTML = expertContent.innerHTML;
      });
      infoLink.addEventListener("keydown", (event) => {
        if (event.key === "Enter") {
          infoLink.click();
        }
      });
    })

  }

  initHealthInfoButton() {
    const healthInfoLinks = [...document.querySelectorAll(".addon__info-details")];
    const infoDrawerContent = document.querySelector(".info-drawer__content");

    healthInfoLinks.forEach((infoLink) => {
      infoLink.addEventListener("click", (event) => {
        event.preventDefault();
        this.open(infoLink);
        infoDrawerContent.innerHTML = document.querySelector('.addon-drawer-content')?.innerHTML || '';
      });
      infoLink.addEventListener("keydown", (event) => {
        if (event.key === "Enter") {
          infoLink.click();
        }
      });
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);

    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {
      this.classList.add("animate", "active");
    });

    document.body.classList.add("overflow-hidden");
  }

  close() {
    this.classList.remove("active");
    removeTrapFocus(this.activeElement);
    document.body.classList.remove("overflow-hidden");
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define("info-drawer", InfoDrawer);
